import * as Sentry from '@sentry/react';

// Initialize Sentry for admin panel
Sentry.init({
  dsn:
    import.meta.env.VITE_SENTRY_DSN ||
    'https://82e53deb94a0190cd3207de97b808779@o4510430492229632.ingest.de.sentry.io/4510430499307600',

  // Set environment from SENTRY_ENV variable
  environment: import.meta.env.VITE_SENTRY_ENV || 'development',

  // Performance Monitoring
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration({
      maskAllText: false,
      blockAllMedia: false,
    }),
  ],

  // Performance monitoring sample rate
  tracesSampleRate: import.meta.env.VITE_SENTRY_ENV === 'production' ? 0.1 : 1.0,

  // Session Replay sample rate
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,

  // Enable logs
  enableLogs: true,

  // Disable in test environment
  enabled: import.meta.env.MODE !== 'test',
});
